(function () {
  const btn = document.querySelector('[data-product-back]');
  if (!btn) return;
  btn.addEventListener('click', (e) => {
    if (window.history.length > 1) {
      e.preventDefault();
      window.history.back();
    }
  });
})();
